import { generateName } from "@common/Common";
import { ExpenseClassification } from "@Quest/Financials/types";

export class CapexAccountEditorViewModel
{
    opened: boolean = false;

    modalTitle: string | null = null;
    confirmButtonLabel: string | null = null;

    id: string | null = null; 
    name: string | null = null;
    description: string | null = null;
    classification: string | null = null;

    showCreator()
    {
        this.id = null;
        this.name = generateName("Capex account");
        this.description = null;
        this.classification = ExpenseClassification.OpEx;

        this.modalTitle = "New capex account";
        this.confirmButtonLabel = "Create";

        this.opened = true;
    }

    showEditor(id: string, name: string, description: string | null, classification: string)
    {
        this.id = id;
        this.name = name;
        this.description = description;
        this.classification = classification;

        this.modalTitle = "Edit the capex account";
        this.confirmButtonLabel = "Update";

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.modalTitle = null;
        this.confirmButtonLabel = null;

        this.id = null;
        this.name = null;
        this.description = null;
        this.classification = null;
    }
}

export class CapexAccountEditorFormSubmitEventPayload
{
    id: string | null;
    name: string;
    description: string | null;
    classification: string;

    constructor(id: string | null, name: string, description: string | null, classification: string)
    {
        this.id = id;
        this.name = name;
        this.description = description;
        this.classification = classification;
    }
}